
import {parse, format, isValid, isEqual, isBefore, isAfter} from 'date-fns/esm'
import {ja} from 'date-fns/esm/locale'
import Vue from 'vue'
import store from 'store'

// Date Object から 書式化日付文字列
export function dateFormat(object, format_) {
  return format(object, format_, {locale: ja})
}

//------------------------------------------------------------------------------

// 内部日付文字列 (または Date Object)  から Date Object
export function dateToObject(any) {
  return any instanceof Date ? any : parse(any, 'yyyyMMdd', 0)
}

// Date Object (または内部日付文字列) から 内部日付文字列
export function dateToString(any) {
  return any instanceof Date ? format(any, 'yyyyMMdd') : any
}

// Date Object (または内部日付文字列) が有意な値か
export function dateIsValid(any) {
  if(!(any instanceof Date)) any = parse(any, 'yyyyMMdd', 0)
  return isValid(any)
}

// 内部日付文字列 または Date Object から フォーマットされた文字列 (format書式はdate-fns format準拠)
export function dateFilter(any, format_ = 'yyyy年M月d日(E)') {
  if(!(any instanceof Date)) any = parse(any, 'yyyyMMdd', 0)
  return isValid(any) ? dateFormat(any, format_) : ''
}

Vue.filter('date', dateFilter)

//------------------------------------------------------------------------------

// 内部時刻文字列 (または Date Object) から Date Object (諸事情につき時分を分秒に置き換えて解釈する)
export function timeToObject(any) {
  return any instanceof Date ? any : parse(any, 'mmss', 0)
}

// Date Object (または内部時刻文字列) から 内部時刻文字列
export function timeToString(any) {
  return any instanceof Date ? format(any, 'mmss') : any
}

// Date Object (または内部時刻文字列) が有意な値か
export function timeIsValid(any, end_any) {
  if(!(any instanceof Date)) any = parse(any, 'mmss', 0)
  if(isValid(any)) {
    if(end_any !== undefined) {
      if(!(end_any instanceof Date)) end_any = parse(end_any, 'mmss', 0)
      return isValid(end_any) && isBefore(any, end_any)
    }
    return true
  }
  return false
}

// 内部時刻文字列 または Date Object から フォーマットされた文字列 (format書式はdate-fns format準拠)
export function timeFilter(any, format_ = 'mm:ss') {
  if(!(any instanceof Date)) any = parse(any, 'mmss', 0)
  return isValid(any) ? dateFormat(any, format_) : ''
}

Vue.filter('time', timeFilter)

//------------------------------------------------------------------------------

// 内部時刻文字列 または Date Object から 時刻ステップ (端数切り捨て)
export function stepFrom(any) {
  const object = timeToObject(any)
  return !isValid(object) ? null
    : Math.floor((object.getMinutes() * 60 + object.getSeconds()) / store.state.timeStepMinutes)
}

// 内部時刻文字列 または Date Object から 時刻ステップ (端数切り上げ)
export function stepFromCeil(any) {
  const object = timeToObject(any)
  return !isValid(object) ? null
    : Math.ceil((object.getMinutes() * 60 + object.getSeconds()) / store.state.timeStepMinutes)
}

// 内部時刻文字列 または Date Object から 時刻ステップ (実績客数データの時刻用)
export function stepFromResult(any) {
  const object = timeToObject(any)
  return !isValid(object) ? null
    : Math.floor((object.getMinutes() * 60 + object.getSeconds() - 1) / store.state.timeStepMinutes)
}

// 時刻ステップ から Date Object
export function stepToObject(step) {
  return new Date(step * store.state.timeStepMinutes * 1000)
}

// 時刻ステップ から 内部時刻文字列
export function stepToString(step) {
  return timeToString(stepToObject(step))
}

// 時刻ステップの差分 から 時間
export function stepToHour(step)
{
  return (step * store.state.timeStepMinutes) / 60;
}

// 時刻ステップ から 表示用時刻文字列 (format書式はdate-fns format準拠)
export function stepFilter(step, format_ = 'mm:ss') {
  return timeFilter(stepToObject(step), format_)
}

Vue.filter('step', stepFilter)

//------------------------------------------------------------------------------

export function isEqualOrBefore(date0, date1) {
  return isBefore(date0, date1) || isEqual(date0, date1)
}

export function isEqualOrAfter(date0, date1) {
  return isAfter(date0, date1) || isEqual(date0, date1)
}

//------------------------------------------------------------------------------

export const weeks = [
  {long: '月曜日', short: '月', eng: 'mon', color: 'black'},
  {long: '火曜日', short: '火', eng: 'tue', color: 'black'},
  {long: '水曜日', short: '水', eng: 'wed', color: 'black'},
  {long: '木曜日', short: '木', eng: 'thu', color: 'black'},
  {long: '金曜日', short: '金', eng: 'fri', color: 'black'},
  {long: '土曜日', short: '土', eng: 'sat', color: 'dodgerblue'},
  {long: '日曜日', short: '日', eng: 'sun', color: 'red'},
  {long: '祝日',   short: '祝', eng: 'hol', color: 'red'},
]
